import './Blogs.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import NavigationBar from '../navbar/NavigationBar';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import BlogsCount from './BlogsCount';

function Blogs() {
    const [ibmmqCnt, setIBMMQCnt] = useState(0);
    const [kafkaCnt, setKafkaCnt] = useState(0);
    const [supplyChainCnt, setSupplyChainCnt] = useState(0);
    const [devSecOpsCnt, setDevSecOpsCnt] = useState(0);
    const [frontendCnt, setFrontEndCnt] = useState(0);
    const [cloudCnt, setCloudCnt] = useState(0);
    const [javaCnt, setJavaCnt] = useState(0);
    const [aiCnt, setAICnt] = useState(0);
    const [solvingCnt, setSolvingCnt] = useState(0);

    const blogCount = () => {
        fetch(process.env.REACT_APP_CONTENT_COUNT_API_URL)
            .then(response => {
                if (response.ok) {
                    response.json().then(jsonArray => {
                        jsonArray.forEach(element => {
                            if (element.formCategory === 'ibmmq') {
                                setIBMMQCnt(element.count);
                            } else if (element.formCategory === 'kafka') {
                                setKafkaCnt(element.count);
                            } else if (element.formCategory === 'supplychain') {
                                setSupplyChainCnt(element.count);
                            } else if (element.formCategory === 'devsecops') {
                                setDevSecOpsCnt(element.count);
                            } else if (element.formCategory === 'frontend') {
                                setFrontEndCnt(element.count);
                            } else if (element.formCategory === 'cloud') {
                                setCloudCnt(element.count);
                            } else if (element.formCategory === 'java') {
                                setJavaCnt(element.count);
                            } else if (element.formCategory === 'ai') {
                                setAICnt(element.count);
                            } else if (element.formCategory === 'solving') {
                                setSolvingCnt(element.count);
                            }
                        });
                    })
                } else {
                    // GET http://localhost:4280/api/content-count?name=ai net::ERR_ABORTED 500 (Internal Server Error)
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <>
            <div className="blogs-bg">
                <NavigationBar></NavigationBar>

                {/* <div className='text-center' style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <audio controls loop controlsList="nodownload" id="music">
                        <source src="./assets/audio/lounge.mp3" type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                    <p style={{ fontFamily: `Cherry Bomb One, cursive`, opacity: '.75' }}>
                        <span style={{ color: 'white', borderRadius: '5px', paddingLeft: '.5rem', paddingRight: '.5rem' }}>
                            Enjoy the complimentary soundtrack for this blogs' site!
                        </span>
                    </p>
                </div> */}

                <Container className="blogs-container" style={{ marginTop: "1rem", marginBottom: "5rem" }}>
                    <Card className='text-center mb-3 blogs-title-card' style={{ background: "rgba(255, 255, 255, .20)" }}>
                        <Card.Body>
                            <Card.Title className='font-cherry-bomb'>Blog Categories</Card.Title>
                        </Card.Body>
                    </Card>

                    <Row xs={1} sm={2} md={3} lg={4} className="g-4" onLoad={blogCount()}>
                        <Col>
                            <Nav.Link as={Link} to="./ibmmq">
                                <Card className="blog-card h-100" style={{ '--card-index': 0 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/ibm-mq-hero.jpeg" />
                                    <Card.Body>
                                        <Card.Title>IBM MQ</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>A message-oriented middleware product that IBM launched in December 1993. It was originally called MQSeries, and was renamed WebSphere MQ in 2002 to join the suite of WebSphere products. In April 2014, it was renamed IBM MQ.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={ibmmqCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./kafka">
                                <Card className="blog-card h-100" style={{ '--card-index': 1 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/kafka.png" />
                                    <Card.Body>
                                        <Card.Title>Kafka</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>An open-source system developed by the Apache Software Foundation written in Java and Scala, used to provide a unified, high-throughput, low-latency platform for handling real-time data feeds.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={kafkaCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./supplychain">
                                <Card className="blog-card h-100" style={{ '--card-index': 2 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/supply-chain.jpg" />
                                    <Card.Body>
                                        <Card.Title>Supply Chain</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>A network of organizations, people, activities, information, and resources involved in handling or distributing and moving a product or service from the supplier to the customer.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={supplyChainCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./devsecops">
                                <Card className="blog-card h-100" style={{ '--card-index': 3 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/devsecops.png" />
                                    <Card.Body>
                                        <Card.Title>DevSecOps</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>The practice of integrating security testing at every stage of the software development process. It includes tools and processes that encourage collaboration between developers, security specialists, and operation teams to build software that is both efficient and secure.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={devSecOpsCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./frontend">
                                <Card className="blog-card h-100" style={{ '--card-index': 4 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/frontend.png" />
                                    <Card.Body>
                                        <Card.Title>Front-End</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>The development of the graphical user interface of a website, through the use of HTML, CSS, and JavaScript, so that users can view and interact with that website.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={frontendCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./cloud">
                                <Card className="blog-card h-100" style={{ '--card-index': 5 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/cloud.png" />
                                    <Card.Body>
                                        <Card.Title>Cloud Computing</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>The on-demand availability of computer system resources, especially data storage and computing power, without direct active management by the user.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={cloudCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./java">
                                <Card className="blog-card h-100" style={{ '--card-index': 6 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/java.jpg" />
                                    <Card.Body>
                                        <Card.Title>Java</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>Java is a high-level, class-based, object-oriented programming language that is designed to have as few implementation dependencies as possible.</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={javaCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./ai">
                                <Card className="blog-card h-100" style={{ '--card-index': 7 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/ai.jpg" />
                                    <Card.Body>
                                        <Card.Title>AI</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>Artificial Intelligence</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={aiCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                        <Col>
                            <Nav.Link as={Link} to="./solving">
                                <Card className="blog-card h-100" style={{ '--card-index': 8 }}>
                                    <Card.Img variant="top" src="./assets/images/blogs/problem-solving.jpeg" />
                                    <Card.Body>
                                        <Card.Title>Problem Solving</Card.Title>
                                        <Card.Text className='d-none d-sm-block'>Examples and techniques of solving problems!</Card.Text>
                                    </Card.Body>
                                    <BlogsCount count={solvingCnt}></BlogsCount>
                                </Card>
                            </Nav.Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Blogs;